import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import useApi from '../../customHook/useApi';
import '../setupyourprofile/SetupYourProfile.css';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

const SetupYourProfile = () => {
  //  if pament successed
  const location = useLocation();
  useEffect(() => {
    // Get query params from URL
    const queryParams = new URLSearchParams(location.search);
    const redirectStatus = queryParams.get('redirect_status');

    // Check if the payment succeeded
    if (redirectStatus === 'succeeded') {
      toast.success('Payment Successful dubey jii!');
    }
  }, [location]);


  const navigate = useNavigate();
  const { data, error, loading, postFormData } = useApi('https://codezens.com/luststory/index.php/api');
  // Get the userId from Redux store
  const userId = useSelector((state) => state.user.userId);

  const [formData, setFormData] = useState({
    user_id: userId,  // Static for now, replace as needed
    username: '',
    name: '',
    gender: '',
    sexuality: '',
    bio: '',
    user_image: null,
    device_token: '',
  });

  // Handle form field changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle file input change (user image)
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData((prev) => ({
      ...prev,
      user_image: file,
    }));
  };

  // Validation function
  const validateForm = () => {

    if (!formData.username) {
      toast.error('Username is required.');
      return false;
    }

    if (!formData.name) {
      toast.error('Name is required.');
      return false;
    }

    if (!formData.gender) {
      toast.error('Gender is required.');
      return false;
    }

    if (!formData.sexuality) {
      toast.error('Sexuality is required.');
      return false;
    }

    if (!formData.bio) {
      toast.error('Bio description is required.');
      return false;
    }

    if (!formData.user_image) {
      toast.error('Profile image is required.');
      return false;
    }

    // if (!formData.termsAccepted) {
    //   toast.error('You must accept the terms and conditions.');
    //   return false;
    // }

    return true // returns true if no errors
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      await postFormData('/signup', formData)  // Add the cookie here
        .then((response) => {
          if (response) {
            console.log('Profile setup successfully', response);
            navigate('/submit-form');
          }
        })
        .catch((err) => {
          console.error('Error submitting profile', err);
        });
    }
  };

  return (
    <div className='SetupYourProfile-section w-100 position-relative'>
      <Link rel='stylesheet' to="/signup" className='back-btn'>Back</Link>
      <div className='SetupYourProfile-code-box d-flex flex-wrap align-content-center justify-content-center'>
        <div className='inner-SetupYourProfile d-flex flex-wrap align-content-center justify-content-center'>
          <div className='SetupYourProfile-form w-100'>
            <h6 className='text-center'>Setup your profile</h6>
            <div className='SetupYourProfile-code-form w-100'>
              <form className='form-section' onSubmit={handleSubmit}>
                <div className="col-md-12 upload-file">
                  <label className="d-none form-label" htmlFor="user_image">Upload</label>
                  <input
                    type="file"
                    className="form-control"
                    id="user_image"
                    onChange={handleFileChange}
                    accept="image/*"
                  />
                  <span className='file-upload-box d-flex flex-wrap align-items-center justify-content-center'>
                    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M26.1816 1.16162V51.1616" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M1.18164 26.0078H51.1816" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </span>
                </div>

                <div className="col-md-12">
                  <label htmlFor="username" className="d-none form-label">Username</label>
                  <input
                    type="text"
                    className="form-control"
                    name="username"
                    id="username"
                    value={formData.username}
                    onChange={handleChange}
                    placeholder="Username"
                  />
                </div>
                <div className="col-md-12">
                  <label htmlFor="name" className="d-none form-label">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    id="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Name"
                  />
                </div>
                <div className="col-md-12">
                  <label htmlFor="gender" className="d-none form-label">Gender</label>
                  <input
                    type="text"
                    className="form-control"
                    name="gender"
                    id="gender"
                    value={formData.gender}
                    onChange={handleChange}
                    placeholder="Gender"
                  />
                </div>
                <div className="col-md-12">
                  <label htmlFor="sexuality" className="d-none form-label">Sexuality</label>
                  <input
                    type="text"
                    className="form-control"
                    name="sexuality"
                    id="sexuality"
                    value={formData.sexuality}
                    onChange={handleChange}
                    placeholder="Sexuality"
                  />
                </div>
                <div className="col-md-12">
                  <label htmlFor="bio" className="d-none form-label">Bio description</label>
                  <textarea
                    className="form-control"
                    name="bio"
                    id="bio"
                    rows="3"
                    value={formData.bio}
                    onChange={handleChange}
                    placeholder="Bio description"
                  />
                </div>

                <p className='text-center mt-4'>
                  <button type="submit" className="btn btn-primary">Next</button>
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SetupYourProfile;
